import React from "react"
import Header from "../components/Header/Header"
import Footer from "../components/Footer/Footer"

import "../styles/style.less"
import "../styles/animate.css"
import "../styles/owl.carousel.css"
import "../styles/off-canvas.css"
import "../styles/magnific-popup.css"
import "../styles/rsmenu-main.css"
import "../styles/rs-spacing.css"
import "../styles/responsive.css"

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

export default function Layout({ children }) {
  return (
    <>
      <div className="offwrap"></div>

      <div className="main-content">
        <div className="full-width-header">
          <Header />
        </div>

        <div className='container'>
          <div className='row y-middle'>
            <div className='col-lg-12'>
              <main>
                {children}
              </main>
            </div>
          </div>
        </div>

        <Footer />
      </div>
    </>
    )
  }
